import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import MixinStock from '@/mixins/stock'
import { StockMolecule, StockFatMolecule } from '@/interfaces/stock'
import ModelMolecule from '@/models/molecule'
import { uuid } from '@/shared/utils'
import MixinFats from '@/mixins/fats'

@Component
export default class ChooseFat extends mixins(MixinStock, MixinFats) {
  get fats(): StockFatMolecule[] {
    return this.stockFats
      .filter((stockFat: StockMolecule) => {
        return stockFat.chainLengths[0] > 0 && stockFat.chainLengths[0] < 20
      })
      .sortBy((stockFat: StockMolecule) => {
        return stockFat.chainLengths[0]
      })
      .transform((stockFat: StockMolecule) => {
        return {
          ids: stockFat.ids,
          title: this.fatGetTitle(stockFat.chainLengths[0], stockFat.doubleBindings[0]),
          chainLengths: stockFat.chainLengths,
          doubleBindings: stockFat.doubleBindings,
        }
      })
      .all()
  }

  public onCreateFat(index: number) {
    this.$modal.close('choose-fat')

    const stockFat: StockFatMolecule = this.fats[index]
    const molecule: ModelMolecule = this.$molecules.find(stockFat.ids[0])

    this.storeAddPawn({
      id: uuid(),
      molecule,
      player: this.activePlayer,
      team: this.activeTeam,
      chainLengths: stockFat.chainLengths,
      doubleBindings: stockFat.doubleBindings,
    })

    this.stockRemoveMolecule(molecule, stockFat.chainLengths, stockFat.doubleBindings)
    this.storeUpdatePawnAmount({
      player: this.activePlayer,
      amount: -1,
    })
  }
}
